<template>
  <div id="imageWorkDetail" v-if="data.workInfo != null">
    <div class="imageWorkDetail-container">
      <div class="search-box">
        <div class="icon-box">
          <i class="el-icon-search"></i>
        </div>
        <div class="input-box">
          <input />
        </div>
      </div>
      <div class="bread-title">
        <div class="list-name">
          <span class="typename" @click="goBack"
            >{{ route.query.type == 2 ? "自由主题作品" : "主题作品" }} ></span
          >
          <span style="margin-right: 10px">{{ data.workInfo.authorName }} </span
          ><span>{{ data.workInfo.name }}</span>
        </div>
      </div>
      <div class="title">
        <span>{{ data.workInfo.authorName }}</span
        ><span>{{ data.workInfo.name }}</span>
      </div>
      <div class="work-desc">
        <p>
          {{ data.workInfo.description }}
        </p>
      </div>
      <div class="Image-box">
        <div
          v-for="(item, index) in data.workInfo.contents"
          :key="index"
          class="imagItem"
        >
          <el-image
            style="width: 100%; height: 100%"
            :src="item"
            :fit="'cover'"
            @contextmenu.prevent.stop="rightClick($event)"
          >
          </el-image>
        </div>

        <!-- <div
          class="imagItem"
          v-for="(item, index) in data.workInfo.contents"
          :key="index"
          :style="{
            backgroundImage: 'url(' + item + ')',
          }"
        ></div> -->
      </div>
      <div class="share-wrap">
        <div class="share-text">点击分享:</div>
        <el-popover
          placement="top"
          :width="100"
          trigger="click"
          @show="showCode"
          style="min-width: auto"
        >
          <template #reference>
            <div
              class="share-icon"
              @click="shareEvent('wechat')"
              :style="{
                backgroundImage: `url(${require(`../assets/img/share/wechat.png`)})`,
              }"
            ></div>
          </template>
          <div id="qrcode" ref="qrcode" style="width: 100px"></div>
        </el-popover>
        <div v-for="(item, index) in shareIcon" :key="index">
          <div
            v-if="item !== 'wechat'"
            class="share-icon"
            :class="{ 'copy-url': item === 'url' }"
            @click="shareEvent(item)"
            :style="{
              backgroundImage: `url(${require(`../assets/img/share/${item}.png`)})`,
            }"
          ></div>
        </div>
      </div>
      <!-- <button @click="copyUrl">复制</button> -->
      <input v-model="currentUrl" id="copyValue" readonly style="opacity: 0" />
    </div>
  </div>
</template>

<script>
import { ref, reactive, nextTick } from "vue";
import QRCode from "qrcodejs2";

// import { ElMessage } from "element-plus";
import { microBlog, qqSpace, QQ } from "../utils/share";
import { useRoute, useRouter } from "vue-router";
import { getById, markView, increaseView } from "../utils/apis/worksApi.js";
import baseInfo from "../utils/config";

export default {
  setup() {
    const coverImage = ref(
      "https://cyc-test.oss-cn-shanghai.aliyuncs.com/design-competition/2021-04-23/16191407496701618967035552.jpg"
    );
    const route = useRoute();
    const router = useRouter();
    const shareIcon = reactive(["wechat", "QQ", "weibo", "qqSpace"]);
    const currentUrl = ref(window.location.href);
    const markRes = ref("");
    const qrcodes = ref(null);
    const data = reactive({
      workInfo: null,
    });
    getDetail();
    mark();
    document.οnmοusedοwn = function (event) {
      if (window.event && !event) {
        event = window.event;
      }

      var ref = event.target || event.srcElement;

      if (ref.tagName == "IMG") {
        if (event.button == 2 || event.button == 3) {
          alert("对不起,本网站不提供图片右键功能,谢谢您的理解和支持!");

          return false;
        }
      }
    };

    function qrcode() {
      console.log(baseInfo);
      if (qrcodes.value) {
        qrcodes.value.clear();
        qrcode();
      } else {
        let url =
          route.query.type === 1
            ? `
        ${baseInfo.MOBILE_URL}themeWorksImageWorkDetail?id=${route.query.id}&type=${route.query.type}&cate=${route.query.type}&views=${route.query.views}`
            : `${baseInfo.MOBILE_URL}freeThemeWorksImageWorkDetail?id=${route.query.id}&type=${route.query.type}&cate=${route.query.type}&views=${route.query.views}`;
        qrcodes.value = new QRCode("qrcode", {
          width: 100,
          height: 100, // 高度
          text: url, // 二维码内容
          // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
          // background: '#f0f'
          // foreground: '#ff0'
        });
      }
    }

    async function showCode() {
      await nextTick();
      qrcode();
    }

    /**
     * 分享
     */
    async function shareEvent(type) {
      console.log(type);
      if (type === "QQ") {
        let mobileurl =
          route.query.type === 1
            ? `
        ${baseInfo.MOBILE_URL}themeWorksImageWorkDetail?id=${route.query.id}&type=${route.query.type}&cate=${route.query.type}&views=${route.query.views}`
            : `${baseInfo.MOBILE_URL}freeThemeWorksImageWorkDetail?id=${route.query.id}&type=${route.query.type}&cate=${route.query.type}&views=${route.query.views}`;
        let url = QQ({
          author: data.workInfo.authorName,
          worksname: data.workInfo.name,
          description: data.workInfo.description,
          url: mobileurl,
          pic: data.workInfo.contents[0],
        });

        console.log(url);
        window.open(encodeURI(url));
      }
      if (type === "qqSpace") {
        let url = qqSpace({
          author: data.workInfo.authorName,
          worksname: data.workInfo.name,
          description: data.workInfo.description,
          url: location.href,
          pic: data.workInfo.contents[0],
        });

        console.log(url);
        window.open(encodeURI(url));
      }
      //微博
      if (type === "weibo") {
        let url = microBlog({
          author: data.workInfo.authorName,
          worksname: data.workInfo.name,
          url: location.href,
          pic: data.workInfo.contents[0],
        });
        window.open(encodeURI(url));
      }
    }
    function getDetail() {
      getById({ id: route.query.id }).then((res) => {
        console.log(res);
        if (res.data.code === 200) {
          data.workInfo = res.data.data;
        }
      });
    }

    function goBack() {
      if (route.query.type == 2) {
        router.push({ path: "/freeThemeWorks" });
      } else {
        router.push({ path: "/ThemeWorks" });
      }
    }

    // function copyUrl() {
    //   // alert(location.href);
    //   var obj = document.getElementById("copyValue");
    //   obj.select();
    //   document.execCommand("Copy");
    //   ElMessage.success("已复制到剪贴板！");
    // }

    function mark() {
      markView({ id: route.query.id }).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          markRes.value = res.data.data;
          setTimeout(() => {
            saveView();
          }, 6000);
        }
      });
    }

    function saveView() {
      increaseView({ id: route.query.id, code: markRes.value }).then((res) => {
        console.log(res);
      });
    }

    function rightClick(event) {
      console.log(event);
    }
    return {
      coverImage,
      shareIcon,
      shareEvent,
      // copyUrl,
      currentUrl,
      route,
      goBack,
      data,
      qrcode,
      showCode,
      rightClick,
    };
  },
};
</script>

<style lang="less" scoped>
#imageWorkDetail {
  .imageWorkDetail-container {
    max-width: 1600px;
    min-width: 1200px;
    margin: 0 auto;
    padding-top: 30px;
    overflow: hidden;
  }

  .search-box {
    margin: 0 0 25px 0;
    height: 30px;
    display: flex;
    line-height: 30px;
    border-radius: 15px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    width: 240px;
    padding-left: 15px;
    .icon-box {
      font-size: 22px;
      color: #dcdfe6;
    }
    .input-box {
      font-size: 0px;
      height: 28px;
      padding-left: 10px;
    }
    .input-box input {
      border: none;
      box-sizing: border-box;
      height: 100%;
      outline: none;
      color: #909399;
      width: 170px;
      background-color: #ffff;
    }
  }
  .bread-title {
    height: 30px;
    line-height: 30px;
    overflow: hidden;
  }
  .list-name {
    float: left;
    margin-right: 25px;
    span:first-child {
      margin-right: 8px;
      margin-left: 5px;
    }
    .typename {
      font-weight: normal;
      cursor: pointer;
    }
    .typename:hover {
      color: #013589;
      margin-right: 8px;
    }
    span {
      font-weight: bold;
      color: #000;
    }
  }

  .title {
    color: #303133;
    font-weight: bold;
    font-size: 18px;
    margin-top: 45px;
    height: 20px;
    line-height: 20px;
    margin-bottom: 20px;
    span:first-child {
      margin-right: 8px;
    }
  }
  .work-desc {
    line-height: 30px;
    color: #303133;
    margin-bottom: 45px;
  }
  .Image-box {
    padding-bottom: 40px;
  }
  .imagItem {
    // height: 820px;
    // background-repeat: no-repeat;
    // background-size: contain;
    // background-position: center;
    margin: 0 auto;
    margin-bottom: 40px;
    max-width: 1920px;
    min-width: 1200px;
    text-align: center;
  }

  .share-wrap {
    float: right;
    display: flex;
    // width: 220px;
    margin-bottom: 60px;

    justify-content: space-between;
    overflow: hidden;
    .share-text {
      font-size: 16px;
      color: #909399;
      line-height: 32px;
      margin-right: 20px;
    }
    .share-icon {
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      width: 40px;
      height: 32px;
      cursor: pointer;
    }
  }
}
</style>
<style>
.el-popover.el-popper {
  min-width: auto;
}
</style>
